import DatePicker from "app/components/DatePicker"
import { DropdownIcon } from "app/components/Icons"
import Textarea from "app/components/Icons/Textarea"
import Input from "app/components/Input"
import MemberProfile from "app/components/MemberProfile"
import { selectUserFormData } from "app/redux/selector"
import React from "react"
import { useSelector } from "react-redux"
import Assignee from "../containers/Tickets/TicketFields/ColumnCustomize/Assignee"

export default function AddRelease() {
   const userForm = useSelector(selectUserFormData);
    const defaultAssignee = {
        name: userForm?.fullName,
        color: '',
        status: "online" as "online",
        initials: userForm?.fullName?.split(' ').map((name: string) => name[0]).join(''),
        online: true,
    }
    return (
        <div className="flex flex-col px-[24px] py-4 pt-[12px] gap-4">
            <div className="flex flex-col gap-y-4">
                <Input
                    label="Release name"
                    placeholder="Enter release name..."
                    id='release-name'
                    inputClassName='!h-[48px] !gap-[0px]'
                    innerContainerClassName="!gap-[0px]"
                />
                <div className="grid grid-cols-2 gap-x-[10px]">
                    <DatePicker
                        label="Start date"
                        value={new Date()}
                        onChange={() => {}}
                        innerContainerClassName="!gap-[0px]"
                    />
                    <DatePicker
                        label="Release date"
                        value={new Date()}
                        onChange={() => {}}
                        innerContainerClassName="!gap-[0px]"
                        align="end"
                    />
                </div>
               {/* <Assignee
                    dropdownTrigger={
                    defaultAssignee ? (
                        <div className="flex items-center gap-1 h-[48px] px-3 border rounded-md">
                           <MemberProfile
                            iconColor={defaultAssignee?.color ?? "#79808A"}
                            iconBgColor={"#F5F6FA"}
                            iconText={defaultAssignee?.initials ?? defaultAssignee?.name[0]}
                            name={defaultAssignee.name ?? defaultAssignee?.name[0]}
                            statusColor="#F00"
                            iconClassName="w-6 h-6"
                            />
                            <DropdownIcon size={16}/>
                        </div>
                        ) : (
                        <div>
                            <Input
                            label="Assignee"
                            placeholder="Select assignee"
                            id="assignee"
                            inputClassName="!h-[48px] !gap-[0px]"
                            innerContainerClassName="!gap-[0px]"
                            endIcon={<DropdownIcon size={16} />}
                            />
                        </div>
                        )
                    }
                    assignedTo={''}
                    dropdownContainerClassName="max-h-[280px] overflow-scroll"
                    className="min-w-[345px]"
                    /> */}
                <Textarea
                    label="Release description"
                    placeholder="Enter release description"
                    id='release-description'
                    inputClassName='!gap-[0px]'
                    innerContainerClassName="!gap-[0px]"
                />
            </div>
        </div>
    )
}